import { render } from "./simpeg-pegawai-import2.vue?vue&type=template&id=795f8fe5"
import script from "./simpeg-pegawai-import2.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-import2.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-import2.vue?vue&type=style&index=0&id=795f8fe5&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__